<template>
<a href="/coupon/usedCoupon.html" :class="current" >
	<i class="icon icon-coupon_loseEfficacy"></i><span>失效券</span>
</a>
</template>
<script>
import maple from 'maple';
export default {
	props: ['current']
}
</script>